import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FaGoogle, FaApple, FaGooglePlay, FaEye, FaEyeSlash } from "react-icons/fa";
import { signInWithGooglePopup } from "../../utils/firebase.utils";
import { getAuth, OAuthProvider, signInWithPopup } from "firebase/auth";
import { FaRegUser } from "react-icons/fa6";
import { FaLock } from "react-icons/fa";
import { syncProfileLanguageFromGetProfile } from "../../utils/profileLanguageSync";
import google from "../Assets/google.jpg";
import { useTranslation } from "react-i18next";
//import { color } from "html2canvas/dist/types/css/types/color";

// Modal Component
const Modal = ({ show, onClose, title, message }) => {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.container}>
        <h2>{title}</h2>
        <p>{message}</p>
        <button style={modalStyles.modalButton} onClick={onClose}>{t("loginPage.close")}</button>
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  },
  container: {
    background: "radial-gradient(circle,rgba(26, 26, 26, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
    padding: "20px",
    borderRadius: "5px",
    textAlign: "center",
    color: "#DFBD69",
  },
  modalButton: {
      width: "100%",
      padding: "10px",
      marginBottom: "10px",
      borderRadius: "5px",
      border: "1px solid #DFBD69",
      backgroundColor: "#DFBD69",
      cursor: "pointer",
      fontSize: "16px",
      textAlign: "center",
    },
};

// LoginSignup Component
const LoginSignup = (props) => {
  const { t } = useTranslation();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", message: "" });
  const [message, setMessage] = useState("");
  const [isLoginVisible, setIsLoginVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state && location.state.message) {
      setMessage(location.state.message);
      setIsLoginVisible(true); // Show login panel when there's a message
    }
  }, [location.state]);

  // Wake up the IIS app pool on mount so it's ready when the user clicks login
  useEffect(() => {
    fetch("https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        UserName: "",
        Password: "",
        Token: { AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp" },
      }),
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onClickk = () => {
    if (username && password === "demo") {
      if (username === "master") {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("username", "demo");
        navigate("/mainmasters");
      } else {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("username", "demo");
        navigate("/chart");
        window.location.reload();
      }
    } else {
      setModalContent({
        title:
          !username || !password ? t("loginPage.missingCredentials") : t("loginPage.wrongCredentials"),
        message:
          !username || !password
            ? t("loginPage.pleaseEnterCredentials")
            : t("loginPage.usernameOrPasswordIncorrect"),
      });
      setIsModal(true);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      // Trigger Google sign-in popup
      const result = await signInWithGooglePopup();

      const name = result.user.displayName;
      const email = result.user.email;
      console.log("User Details:", result);
      console.log("User:", name, email);

      // Check if user account exists by calling the API
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/Booking/getEmailAuth?email=${email}`
      );
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const apiData = await response.json();
      setPassword(apiData[0].PASSWORD);

      // Check if account exists
      if (apiData.length === 0 || !apiData[0]?.ID) {
        const today = new Date().toLocaleString();
        try {
          const response = await fetch(
            "https://xianhefairy.com/LotusFairy_API/api/user/ProfileSaveUpdate?token = xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ID: "0",
                RefNo: "",
                FName: name,
                LName: "",
                DateOfBirth: today,
                ChineseDateOfBirth: today,
                Gender: "Male",
                Age: "0",
                MobileNo: "0",
                Country: 2143,
                Email: email,
                Password: "098786500",
              }),
            }
          );

          if (!response.ok) {
            throw new Error("Request failed with status " + response.status);
          }
          const result = await response.json();
          if (result) {
            console.log("sucess");
            const url =
              "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
            const data = {
              UserName: email,
              Password: password,
              Token: {
                AccessToken:
                  "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
              },
            };
            try {
              const response = await fetch(url, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              });

              const result = await response.json();

              // Assuming your API returns a field 'success' for login status
              if (result && result.ID !== null && result.ID !== undefined) {
                // Do NOT store plaintext passwords in localStorage.
                localStorage.setItem("username", result.username);
                localStorage.setItem("userID", result.ID);
                localStorage.setItem("name", result.FullName);
                localStorage.setItem("isLoggedIn", "true");
                localStorage.setItem("roletype", result.Role);
                await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

                // Navigate based on the username
                if (result.Role === "Master") {
                  navigate("/mainmasters");
                } else if (result.Role === "Member") {
                  navigate("/chart");
                  try {
                    const response = await fetch(
                      `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                    );
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    localStorage.setItem("coins", data[0].COINS);
                  } catch (error) {
                    console.error("Error fetching coins:", error);
                  }

                  try {
                    const response = await fetch(
                      `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                    );
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    localStorage.setItem("comcoins", data[0].COINS);
                  } catch (error) {
                    console.error("Error fetching coins:", error);
                  }
                  window.location.reload();
                }
              } else {
                setModalContent({
                  title: t("loginPage.wrongCredentials"),
                  message: t("loginPage.usernameOrPasswordIncorrect"),
                });
                setIsModal(true);
                console.log(result);
              }
            } catch (error) {
              setModalContent({
                title: t("loginPage.connectionError"),
                message: t("loginPage.loginError"),
              });
              setIsModal(true);
              console.error("Login error:", error);
            }
          }
        } catch (error) {
          console.error("Sign-up error:", error);
        }
      } else {
        console.log("Account found:", apiData[0]);
        const pass = apiData[0]?.PASSWORD;
        const url =
          "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
        const data = {
          UserName: email,
          Password: pass,
          Token: {
            AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
          },
        };
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });

          const result = await response.json();
          console.log(data);

          // Assuming your API returns a field 'success' for login status
            if (result && result.ID !== null && result.ID !== undefined) {
            // Do NOT store plaintext passwords in localStorage.
            localStorage.setItem("username", result.username);
            localStorage.setItem("userID", result.ID);
            localStorage.setItem("name", result.FullName);
            localStorage.setItem("isLoggedIn", "true");
            localStorage.setItem("roletype", result.Role);
            await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

            // Navigate based on the username
            if (result.Role === "Master") {
              navigate("/mainmasters");
            } else if (result.Role === "Member") {
              navigate("/chart");
              try {
                const response = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                );
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                localStorage.setItem("coins", data[0].COINS);
              } catch (error) {
                console.error("Error fetching coins:", error);
              }

              try {
                const response = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                );
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                localStorage.setItem("comcoins", data[0].COINS);
              } catch (error) {
                console.error("Error fetching coins:", error);
              }
              window.location.reload();
            }
          } else {
            setModalContent({
              title: "Wrong Credentials",
              message: "Username or password is incorrect.",
            });
            setIsModal(true);
            console.log(result);
          }
        } catch (error) {
          setModalContent({
            title: "Error",
            message: "An error occurred during login. Please try again.",
          });
          setIsModal(true);
          console.error("Login error:", error);
        }
      }
    } catch (error) {
      console.error("Error during Google Sign-In or API call:", error);
    }
  };

  const handleAppleSignIn = async () => {
    const auth = getAuth();
    const provider = new OAuthProvider("apple.com");

    try {
      const result = await signInWithPopup(auth, provider);

      // Get the signed-in user's info
      const user = result.user;
      const name = result.user.displayName;
      const email = result.user.email;
      console.log("User Info:", user);
      console.log("User:", name, email);

      // Get Apple-specific OAuth token
      const credential = OAuthProvider.credentialFromResult(result);
      const accessToken = credential.accessToken;
      const idToken = credential.idToken;
      console.log("Access Token:", accessToken);
      console.log("ID Token:", idToken);

      try {
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Booking/getEmailAuth?email=${email}`
        );
        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }
        const apiData = await response.json();
        setPassword(apiData[0].PASSWORD);
        // Check if account exists
        if (apiData.length === 0 || !apiData[0]?.ID) {
          const today = new Date().toLocaleString();
          try {
            const response = await fetch(
              "https://xianhefairy.com/LotusFairy_API/api/user/ProfileSaveUpdate?token = xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  ID: "0",
                  RefNo: "",
                  FName: name,
                  LName: "",
                  DateOfBirth: today,
                  ChineseDateOfBirth: today,
                  Gender: "Male",
                  Age: "0",
                  MobileNo: "0",
                  Country: 2143,
                  Email: email,
                  Password: "098786500",
                }),
              }
            );

            if (!response.ok) {
              throw new Error("Request failed with status " + response.status);
            }
            const result = await response.json();
            if (result) {
              console.log("sucess");
              const url =
                "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
              const data = {
                UserName: email,
                Password: password,
                Token: {
                  AccessToken:
                    "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
                },
              };
              try {
                const response = await fetch(url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(data),
                });

                const result = await response.json();

                // Assuming your API returns a field 'success' for login status
                if (result && result.ID !== null && result.ID !== undefined) {
                  // Do NOT store plaintext passwords in localStorage.
                  localStorage.setItem("username", result.username);
                  localStorage.setItem("userID", result.ID);
                  localStorage.setItem("name", result.FullName);
                  localStorage.setItem("isLoggedIn", "true");
                  localStorage.setItem("roletype", result.Role);
                  await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

                  // Navigate based on the username
                  if (result.Role === "Master") {
                    navigate("/mainmasters");
                  } else if (result.Role === "Member") {
                    navigate("/chart");
                    try {
                      const response = await fetch(
                        `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                      );
                      if (!response.ok) {
                        throw new Error("Network response was not ok");
                      }
                      const data = await response.json();
                      localStorage.setItem("coins", data[0].COINS);
                    } catch (error) {
                      console.error("Error fetching coins:", error);
                    }

                    try {
                      const response = await fetch(
                        `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                      );
                      if (!response.ok) {
                        throw new Error("Network response was not ok");
                      }
                      const data = await response.json();
                      localStorage.setItem("comcoins", data[0].COINS);
                    } catch (error) {
                      console.error("Error fetching coins:", error);
                    }
                    window.location.reload();
                  }
                } else {
                  setModalContent({
                    title: "Wrong Credentials",
                    message: "Username or password is incorrect.",
                  });
                  setIsModal(true);
                  console.log(result);
                }
              } catch (error) {
                setModalContent({
                  title: "Error",
                  message: "An error occurred during login. Please try again.",
                });
                setIsModal(true);
                console.error("Login error:", error);
              }
            }
          } catch (error) {
            console.error("Sign-up error:", error);
          }
        } else {
          console.log("Account found:", apiData[0]);
          // const password = apiData[0]?.PASSWORD;
          const url =
            "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
          const data = {
            UserName: email,
            Password: password,
            Token: {
              AccessToken:
                "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            },
          };
          try {
            const response = await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            });

            const result = await response.json();
            console.log(data);

            // Assuming your API returns a field 'success' for login status
            if (result && result.ID !== null && result.ID !== undefined) {
              // Do NOT store plaintext passwords in localStorage.
              localStorage.setItem("username", result.username);
              localStorage.setItem("userID", result.ID);
              localStorage.setItem("name", result.FullName);
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem("roletype", result.Role);
              await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

              // Navigate based on the username
              if (result.Role === "Master") {
                navigate("/mainmasters");
              } else if (result.Role === "Member") {
                navigate("/chart");
                try {
                  const response = await fetch(
                    `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                  );
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  const data = await response.json();
                  localStorage.setItem("coins", data[0].COINS);
                } catch (error) {
                  console.error("Error fetching coins:", error);
                }

                try {
                  const response = await fetch(
                    `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                  );
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  const data = await response.json();
                  localStorage.setItem("comcoins", data[0].COINS);
                } catch (error) {
                  console.error("Error fetching coins:", error);
                }
                window.location.reload();
              }
            } else {
              setModalContent({
                title: "Wrong Credentials",
                message: "Username or password is incorrect.",
              });
              setIsModal(true);
              console.log(result);
            }
          } catch (error) {
            setModalContent({
              title: "Error",
              message: "An error occurred during login. Please try again.",
            });
            setIsModal(true);
            console.error("Login error:", error);
          }
        }
      } catch (error) {
        console.error("Error during Google Sign-In or API call:", error);
      }
    } catch (error) {
      console.error("Error signing in with Apple:", error);
      if (error.code === "auth/cancelled-popup-request") {
        alert("Sign-in process was cancelled. Try again.");
      }
    }
  };

  const fetchWithRetry = async (url, options, retries = 2) => {
    for (let i = 0; i <= retries; i++) {
      try {
        const response = await fetch(url, options);
        return response;
      } catch (err) {
        const isNetworkError = err instanceof TypeError;
        if (isNetworkError && i < retries) {
          await new Promise((res) => setTimeout(res, 1000));
          continue;
        }
        throw err;
      }
    }
  };

  const onClick = async () => {
    if (!username || !password) {
      setModalContent({
        title: t("loginPage.missingCredentials"),
        message: t("loginPage.pleaseEnterCredentials"),
      });
      setIsModal(true);
      return;
    }

    const url = "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin";
    const data = {
      UserName: username,
      Password: password,
      Token: {
        AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
      },
    };
    try {
      const response = await fetchWithRetry(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      // Assuming your API returns a field 'success' for login status
      if (result && result.ID !== null && result.ID !== undefined) {
        // Do NOT store plaintext passwords in localStorage.
        localStorage.setItem("username", username);
        localStorage.setItem("userID", result.ID);
        localStorage.setItem("name", result.FullName);
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("roletype", result.Role);
        await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: username });

        // Navigate based on the username
        if (result.Role === "Master") {
          navigate("/mainmasters");
        } else if (result.Role === "Member") {
          navigate("/chart");
          try {
            const response = await fetch(
              `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
            );
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            localStorage.setItem("coins", data[0].COINS);
          } catch (error) {
            console.error("Error fetching coins:", error);
          }

          try {
            const response = await fetch(
              `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
            );
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            localStorage.setItem("comcoins", data[0].COINS);
          } catch (error) {
            console.error("Error fetching coins:", error);
          }
          window.location.reload();
        }
      } else {
        setModalContent({
          title: t("loginPage.wrongCredentials"),
          message: t("loginPage.usernameOrPasswordIncorrect"),
        });
        setIsModal(true);
        console.log(result);
      }
    } catch (error) {
      const isNetworkError = error instanceof TypeError &&
        (error.message === "Failed to fetch" || error.message === "Load failed");
      setModalContent({
        title: t("loginPage.connectionError"),
        message: isNetworkError
          ? t("loginPage.unableToConnect")
          : t("loginPage.loginError"),
      });
      setIsModal(true);
      console.error("Login error:", error);
    }
  };

  const toggleLogin = () => {
    setIsLoginVisible(!isLoginVisible);
  };

  const goToMain = () => {
    navigate("/main");
  };

  const checkLoginAndOrder = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      // Proceed with order logic, for example:
      console.log("Proceeding with order...");
    } else {
      navigate("/login", {
        state: { message: "You need to log in before placing an order." },
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Open modal on mount
  useEffect(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const pageStyle = {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    position: isMobile ? "fixed" : "relative",
    top: isMobile ? 0 : undefined,
    left: isMobile ? 0 : undefined,
    width: isMobile ? "100vw" : "100%",
    flexDirection: isMobile ? "column" : "row", // Stack vertically on mobile
    zIndex: isMobile ? 999 : "auto",
  };

  const slideshowContainerStyle = {
    flex: isLoginVisible ? 0.75 : 1,
    transition: "flex 0.5s ease",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const loginContainerStyle = {
    position: isMobile ? "fixed" : "absolute",
    top: isMobile ? 0 : undefined,
    left: isMobile ? 0 : undefined,
    bottom: isMobile ? undefined : 0,
    right: isMobile ? undefined : 0,
    width: isMobile ? "100vw" : isLoginVisible ? "100%" : "0%",
    height: isMobile ? "100vh" : "100%", // Full height on mobile
    background: "linear-gradient(to right, #1B0E3C, #0A031E)",
    display: isLoginVisible || isMobile ? "flex" : "none",
    justifyContent: "center",
    alignItems: "center",
    padding: isMobile ? "10px" : "20px", // Reduced padding on mobile
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    transition: "width 0.5s ease",
    overflowY: isMobile ? "auto" : "visible", // Allow scrolling on mobile
    zIndex: isMobile ? 1000 : "auto",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: isMobile ? "350px" : "400px", // Smaller max width on mobile
    padding: isMobile ? "15px" : "20px", // Reduced padding on mobile
    textAlign: "center",
  };

  const headerStyle = {
    color: "white",
    fontFamily: "sans-serif",
    fontWeight: "700",
    fontSize: isMobile ? "20px" : "24px", // Smaller font on mobile
    marginBottom: "10px",
  };

  const underlineStyle = {
    width: "50px",
    height: "4px",
    background: "white",
    borderRadius: "9px",
    margin: "auto",
    marginBottom: isMobile ? "15px" : "20px", // Reduced margin on mobile
  };

  const inputWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? "10px" : "15px", // Reduced gap on mobile
    alignItems: "center",
  };

  const inputStyle = {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: isMobile ? "45px" : "50px", // Slightly smaller on mobile
    background: "#8D78C1",
    placeholderTextColor: "white",
    borderRadius: "25px",
    padding: "0 10px",
    marginBottom: "10px",
    border: "1px solid white",
    color: "black",
  };

  const inputFieldStyle = {
    width: "100%",
    height: isMobile ? "35px" : "40px", // Smaller height on mobile
    background: "transparent",
    border: "none",
    outline: "none",
    color: "black",
    fontSize: isMobile ? "14px" : "16px", // Smaller font on mobile
  };

  const buttonStyle = {
    padding: isMobile ? "8px" : "10px", // Reduced padding on mobile
    backgroundColor: "#8D78C1",
    width: isMobile ? "60%" : "50%", // Slightly wider on mobile
    borderRadius: "30px",
    color: "white",
    border: "none",
    fontSize: isMobile ? "14px" : "16px", // Smaller font on mobile
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: isMobile ? "15px" : "20px", // Reduced margin on mobile
  };

  const toggleButtonStyle = {
    position: "absolute",
    bottom: "20px",
    right: "20px",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    display: isMobile ? "none" : "block",
  };

  const toggleSkipButtonStyle = {
    position: "absolute",
    bottom: "20px",
    right: "170px",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    display: isMobile ? "none" : "block",
  };

  const linkStyle = {
    color: "#DFBD69",
    textDecoration: "none",
  };

  const modalStyle = {
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    borderRadius: "8px",
    overflow: "hidden",
    position: "fixed",
    top: 0,
    left: 0,
  };

  const overlayStyle = {
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: isMobile ? "20px" : "0", // Add padding on mobile
  };

  const modalStyle2 = {
    background: "radial-gradient(circle,rgba(26, 26, 26, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
    padding: isMobile ? "15px" : "20px", // Reduced padding on mobile
    borderRadius: "8px",
    minWidth: isMobile ? "280px" : "300px", // Smaller min width on mobile
    maxWidth: isMobile ? "90%" : "none", // Max width on mobile
    color: "#DFBD69",
  };

  const inputStyle2 = {
    width: "100%",
    padding: isMobile ? "6px" : "8px", // Reduced padding on mobile
    marginBottom: "10px",
    fontSize: isMobile ? "14px" : "16px", // Smaller font on mobile
  };

  const buttonStyle2 = {
    backgroundColor: "#DFBD69",
    color: "black",
    padding: isMobile ? "8px" : "10px", // Reduced padding on mobile
    border: "none",
    borderRadius: "4px",
    width: "100%",
    cursor: "pointer",
    fontSize: isMobile ? "14px" : "16px", // Smaller font on mobile
  };

  const errorStyle = {
    color: "white",
    fontSize: isMobile ? "12px" : "14px", // Smaller font on mobile
    marginBottom: "10px",
  };

  //forgot password
  const [step, setStep] = useState(0); // 1: enter email, 2: verify code, 3: new password
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState();
  const [enteredCode, setEnteredCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [reNewPass, setReNewPass] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [codeExpiry, setCodeExpiry] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (step !== 2) return;
    const tick = () => {
      const remaining = Math.max(0, Math.floor((codeExpiry - Date.now()) / 1000));
      setTimeLeft(remaining);
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [step, codeExpiry]);

  const formatTimeLeft = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleSendEmail = async () => {
    try {
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/email/send_reset",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ToEmail: email,
            CreatedBy: email,
          }),
        }
      );
      const result = await res.json();
      if (result) {
        setVerificationCode(result.sentCode); // You might not get the code directly in production
        setErrorMsg("");
        const sentAt = Date.now();
        const expiresAt = sentAt + 10 * 60 * 1000;
        localStorage.setItem("verificationCodeSentAt", sentAt.toString());
        localStorage.setItem("verificationCodeExpiresAt", expiresAt.toString());
        setCodeExpiry(expiresAt);
        setTimeLeft(10 * 60);
        setStep(2);
        console.log(result)
      } else {
        setErrorMsg(result?.Message || "Failed to send reset code.");
        console.log(result)
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Error sending reset email.");
    }
  };

  const handleVerifyCode = () => {
    if (Date.now() > codeExpiry) {
      setErrorMsg("Verification code has expired. Please request a new one.");
      return;
    }
    if (enteredCode == verificationCode) {
      localStorage.removeItem("verificationCodeSentAt");
      localStorage.removeItem("verificationCodeExpiresAt");
      setErrorMsg("");
      setStep(3);
    } else {
      setErrorMsg("Invalid verification code.");
    }
  };

  const validatePassword = (pass) => {
    if (pass.length < 6) return "Password must be at least 6 characters.";
    if (!/[A-Z]/.test(pass)) return "Password must include at least one uppercase letter.";
    if (!/[a-z]/.test(pass)) return "Password must include at least one lowercase letter.";
    if (!/[0-9]/.test(pass)) return "Password must include at least one number.";
    if (!/[^A-Za-z0-9]/.test(pass)) return "Password must include at least one special character.";
    return "";
  };

  const handleChangePassword = async () => {
    const validationError = validatePassword(newPass);
    if (validationError) {
      setErrorMsg(validationError);
      return;
    }
    if (newPass !== reNewPass) {
      setErrorMsg("Passwords do not match.");
      return;
    }

    try {
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/booking/ResetPassword",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Username: email, NewPassword: newPass }),
        }
      );
      const result = await res.json();

      if (res.ok && result?.Success === true) {
        setStep(0);
        setEmail("");
        setNewPass("");
        setReNewPass("");
        setEnteredCode("");
        setErrorMsg("");
        setSuccessMsg("Password reset successfully.");
      } else {
        setErrorMsg(result?.Message || "Failed to update password.");
      }
    } catch (error) {
      console.error(error);
      setErrorMsg("Error updating password.");
    }
  };

  return (
    <div style={pageStyle}>
      {isMobile && (
        <button
          style={{
            position: "absolute",
            top: 16,
            left: 16,
            zIndex: 1100,
            background: "rgba(0,0,0,0.2)",
            border: "none",
            borderRadius: "50%",
            width: 40,
            height: 40,
            color: "#000",
            fontSize: 22,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
          }}
          onClick={props.onClose}
          aria-label="Close"
        >
          X
        </button>
      )}
      <div style={loginContainerStyle}>
        <div style={containerStyle}>
          <h1 style={headerStyle}>{t("loginPage.logIn")}</h1>
          <div style={underlineStyle}></div>
          <div style={inputWrapperStyle}>
            <div style={inputStyle}>
              <div style={{ width: "5%" }} />
              <FaRegUser />
              <div style={{ width: "5%" }} />
              <input
                type="text"
                placeholder={t("loginPage.email")}
                placeholderTextColor="black"
                value={username}
                onChange={(e) => setUserName(e.target.value)}
                style={inputFieldStyle}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onClick();
                  }
                }}
              />
            </div>
            <div style={inputStyle}>
              <div style={{ width: "5%" }} />
              <FaLock />
              <div style={{ width: "5%" }} />
              <input
                type={showPassword ? "text" : "password"}
                placeholder={t("loginPage.password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onClick();
                  }
                }}
                style={inputFieldStyle}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: "0 8px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          <button onClick={onClick} style={buttonStyle}>
            {t("loginPage.logIn")}
          </button>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <button
              onClick={handleGoogleLogin}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 20px",
                fontSize: "16px",
                backgroundColor: "#8D78C1",
                color: "white",
                border: "none",
                borderRadius: "15px",
                cursor: "pointer",
              }}
            >
              <img
                src={google}
                alt="Google Icon"
                style={{
                  marginRight: "8px",
                  width: "20px", // Set the size directly
                  height: "20px",
                  backgroundColor: "#8D78C1",
                }}
              />{" "}
              {t("loginPage.loginWithGoogle")}
            </button>
            {/* <button
              onClick={handleAppleSignIn}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 20px",
                fontSize: "16px",
                backgroundColor: "#000000",
                color: "white",
                border: "none",
                borderRadius: "15px",
                cursor: "pointer",
              }}
            >
              <FaApple style={{ marginRight: "8px", fontSize: "20px" }} /> Login
              with Apple
            </button> */}
          </div>

          <p style={{ marginTop: "20px", color: "white" }}>
            {t("loginPage.dontHaveAccount")}{" "}
            <Link to="/signup" style={linkStyle}>
              {t("loginPage.signUp")}
            </Link>
          </p>

          <button
            style={{
              marginTop: "20px",
              color: "white",
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
            }}
            onClick={() => setStep(1)}
          >
            {t("loginPage.forgotPassword")}
          </button>
        </div>
      </div>
      <Modal
        show={isModal}
        onClose={() => setIsModal(false)}
        title={modalContent.title}
        message={modalContent.message}
      />

      {/* forget pass */}
      {step === 1 && (
        <div style={overlayStyle} onClick={() => setStep(0)}>
          <div style={modalStyle2} onClick={(e) => e.stopPropagation()}>
            <h3>{t("loginPage.resetPassword")}</h3>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("loginPage.enterEmail")}
              style={inputStyle2}
            />
            {errorMsg && <p style={errorStyle}>{errorMsg}</p>}
            <button onClick={handleSendEmail} style={buttonStyle}>
             {t("loginPage.sendCode")}
            </button>
          </div>
        </div>
      )}
      {step === 2 && (
        <div style={overlayStyle} onClick={() => setStep(0)}>
          <div style={modalStyle2} onClick={(e) => e.stopPropagation()}>
            <h3>{t("loginPage.enterVerificationCode")}</h3>
            <p>{t("loginPage.code")}{email}</p>
            <p style={{ color: timeLeft <= 60 ? "#ff6b6b" : "#DFBD69", fontSize: isMobile ? "13px" : "14px", marginBottom: "10px" }}>
              {timeLeft > 0 ? `${t("loginPage.codeExpires")} ${formatTimeLeft(timeLeft)}` : t("loginPage.codeHasExpired")}
            </p>
            <input
              type="text"
              value={enteredCode}
              onChange={(e) => setEnteredCode(e.target.value)}
              placeholder={t("loginPage.enter4digitCode")}
              style={inputStyle2}
              disabled={timeLeft === 0}
            />
            {errorMsg && <p style={errorStyle}>{errorMsg}</p>}
            <button onClick={handleVerifyCode} style={{ ...buttonStyle2, opacity: timeLeft === 0 ? 0.5 : 1, cursor: timeLeft === 0 ? "not-allowed" : "pointer" }} disabled={timeLeft === 0}>
              {t("loginPage.verifyCode")}
            </button>
            {timeLeft === 0 && (
              <button onClick={() => { setStep(1); setEnteredCode(""); setErrorMsg(""); }} style={{ ...buttonStyle2, marginTop: "8px", backgroundColor: "#8D78C1" }}>
                {t("loginPage.resendCode")}
              </button>
            )}
          </div>
        </div>
      )}
      {step === 3 && (
        <div style={overlayStyle} onClick={() => setStep(0)}>
          <div style={modalStyle2} onClick={(e) => e.stopPropagation()}>
            <h3>{t("loginPage.setNewPassword")}</h3>
            <input
              type="password"
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
              placeholder={t("loginPage.newPassword")}
              style={inputStyle2}
            />
            <input
              type="password"
              value={reNewPass}
              onChange={(e) => setReNewPass(e.target.value)}
              placeholder={t("loginPage.reenterPassword")}
              style={inputStyle2}
            />
            {errorMsg && <p style={errorStyle}>{errorMsg}</p>}
            <button onClick={handleChangePassword} style={buttonStyle2}>
              {t("loginPage.updatePassword")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginSignup;
